<div class="row">
   <div style="display: inline-block; text-align: left; width: 65%; margin-top: -20px; vertical-align: top">
      <div style="font-size: 12px; line-height: 17px">
         <strong>Product Code:</strong>
         {{ requestData.newProductCode }}
         <br />
         <strong>Product Name:</strong>
         {{ requestData.newProductName }}
         <br />
         <strong>VCProduct:</strong>
         {{ !!requestData.vcProductSKey ? requestData.vcProductDescription : " Can't find code" }}
         <div *ngIf="!requestData.vcProductSKey">
            <strong>Please describe what this code is and how you will use it in your practice:</strong>
            {{ requestData.cantFindDescription }}
         </div>
         <div *ngIf="requestData.vcProductSKey && requestData.notPerfectReason">
            <strong>Please describe why this standard code is not a perfect match:</strong>
            {{ requestData.notPerfectReason }}
         </div>
         <br />
         <strong>Do you offer a similar code already?</strong>
         {{ !!requestData.similarProductSKey ? "yes" : "no" }}
         <br />
         <ng-container *ngIf="!!requestData.similarProductSKey">
            <strong>What is different about the new code?</strong>
            {{ requestData.similarCodeDifference }}
            <br />
            <strong>If you are switching supplies, what is the old cost?</strong>
            {{ requestData.oldCost | currency }}
            <br />
         </ng-container>
         <strong>What is the link to the source item in your purchasing platform?</strong>
         {{ requestData.productLink }}
         <br />
         <strong>Will you charge a fee? If so, what?</strong>
         {{ !!requestData.productFee ? (requestData.productFee | currency) : "no" }}
         <br />
         <strong>Will you have quantity price breaks? If so what?</strong>
         {{ !!requestData.qtyBreak ? requestData.qtyBreak : "no" }}
         <br />
         <strong>What is your cost for this service/item?</strong>
         {{ requestData.newCost | currency }}
      </div>
      <div class="col-sm-12">
         <div class="form-group row align-items-center mt-4">
            <label
               for="vcpo"
               class="col-sm-3 col-form-label">
               <strong>Override VCProduct</strong>
            </label>
            <div class="col-sm-9">
               <p-autocomplete
                  id="vcpo"
                  [disabled]="readonly()"
                  [overlayOptions]="{ baseZIndex: 1500 }"
                  [(ngModel)]="vcProduct"
                  [suggestions]="searchResults"
                  (completeMethod)="onCodeSearch($event.query)"
                  field="vcProductDescription"
                  appendTo="body"
                  fluid="true"
                  inputStyleClass="p-1"
                  scrollHeight="75vh" />
            </div>
         </div>
         <div class="form-group row align-items-center">
            <label
               for="sco"
               class="col-sm-3 col-form-label">
               <strong>Override Similar Code</strong>
            </label>
            <div class="col-sm-9">
               <p-autocomplete
                  id="sco"
                  [disabled]="readonly()"
                  [overlayOptions]="{ baseZIndex: 1500 }"
                  [(ngModel)]="similarCode"
                  [suggestions]="similarSearchResults()"
                  (completeMethod)="onSimilarCodeSearch($event.query)"
                  [optionLabel]="getPimsProductLabel"
                  appendTo="body"
                  fluid="true"
                  inputStyleClass="p-1"
                  scrollHeight="75vh" />
            </div>
         </div>
      </div>
      <div style="margin-top: 30px">
         <div class="row">
            <div
               class="col-md-5"
               *ngIf="!readonly()">
               <table class="detailsTable">
                  <tr>
                     <td>HM</td>
                     <td>{{ firstHm()?.firstName }} {{ firstHm()?.lastName }}</td>
                  </tr>
                  <tr>
                     <td>COS</td>
                     <td>{{ practice()?.cos.FirstName }} {{ practice()?.cos.LastName }}</td>
                  </tr>
                  <tr>
                     <td>RM</td>
                     <td>{{ practice()?.rm.FirstName }} {{ practice()?.rm.LastName }}</td>
                  </tr>
                  <tr>
                     <td>L12M Revenue</td>
                     <td></td>
                  </tr>
                  <tr>
                     <td>L12M Profitability</td>
                     <td></td>
                  </tr>
                  <tr>
                     <td>YoY Revenue</td>
                     <td></td>
                  </tr>
                  <tr>
                     <td>L3M Revenue</td>
                     <td></td>
                  </tr>
                  <tr>
                     <td>3MoM Revenue</td>
                     <td></td>
                  </tr>
               </table>
               <br />
               <label>Historical Product Data</label>
               <table
                  class="detailsTable"
                  *ngIf="historicalProductData()">
                  <tr>
                     <td>L12M Qty</td>
                     <td>{{ historicalProductData().l12MQty }}</td>
                  </tr>
                  <tr>
                     <td>L12M Revenue</td>
                     <td>{{ historicalProductData().l12MRevenue | currency }}</td>
                  </tr>
                  <tr>
                     <td>L3M Qty</td>
                     <td>{{ historicalProductData().l3MQty }}</td>
                  </tr>
                  <tr>
                     <td>L3M Revenue</td>
                     <td>{{ historicalProductData().l3MRevenue | currency }}</td>
                  </tr>
                  <tr>
                     <td>YoY Qty</td>
                     <td>{{ (historicalProductData().l12MQty - historicalProductData().pL12MQty) / historicalProductData().pL12MQty | percent }}</td>
                  </tr>
                  <tr>
                     <td>YoY Revenue</td>
                     <td>
                        {{
                           (historicalProductData().l12MRevenue - historicalProductData().pL12MRevenue) / historicalProductData().pL12MRevenue
                              | percent
                        }}
                     </td>
                  </tr>
                  <tr>
                     <td>QoQ Qty</td>
                     <td>{{ (historicalProductData().l3MQty - historicalProductData().pL3MQty) / historicalProductData().pL3MQty | percent }}</td>
                  </tr>
                  <tr>
                     <td>QoQ Revenue</td>
                     <td>
                        {{
                           (historicalProductData().l3MRevenue - historicalProductData().pL3MRevenue) / historicalProductData().pL3MRevenue | percent
                        }}
                     </td>
                  </tr>
               </table>
            </div>
            <div class="col-md-7">
               <div
                  class="pt-3 pr-1 pb-3 pl-3"
                  style="background-color: #e8f7f4">
                  <div class="form-group row align-items-center m-2">
                     <label
                        for="op"
                        class="col-sm-4 col-form-label">
                        <strong>Override Old Cost</strong>
                     </label>
                     <div class="col-sm-8">
                        <input
                           id="op"
                           [(ngModel)]="oldCost"
                           [disabled]="readonly()"
                           ngModelOptions="{standalone: true}"
                           type="number"
                           inputmode="decimal"
                           min="0"
                           (keydown)="!['-', 'e'].includes($event.key) || ($event.preventDefault() && false)"
                           class="form-control"
                           style="text-align: right; height: 32px; font-size: 12px; padding-left: 4px; padding-right: 4px" />
                     </div>
                  </div>
                  <div class="form-group row align-items-center m-2">
                     <label
                        for="op"
                        class="col-sm-4 col-form-label">
                        <strong>Override New Cost</strong>
                     </label>
                     <div class="col-sm-8">
                        <input
                           id="op"
                           [(ngModel)]="newCost"
                           [disabled]="readonly()"
                           ngModelOptions="{standalone: true}"
                           type="number"
                           inputmode="decimal"
                           min="0"
                           (keydown)="!['-', 'e'].includes($event.key) || ($event.preventDefault() && false)"
                           class="form-control"
                           style="text-align: right; height: 32px; font-size: 12px; padding-left: 4px; padding-right: 4px" />
                     </div>
                  </div>
                  <div class="form-group row align-items-center m-2">
                     <label
                        for="op"
                        class="col-sm-4 col-form-label">
                        <strong>Override Price</strong>
                     </label>
                     <div class="col-sm-8">
                        <input
                           id="op"
                           [(ngModel)]="newPrice"
                           [disabled]="readonly()"
                           ngModelOptions="{standalone: true}"
                           type="number"
                           inputmode="decimal"
                           min="0"
                           (keydown)="!['-', 'e'].includes($event.key) || ($event.preventDefault() && false)"
                           class="form-control"
                           style="text-align: right; height: 32px; font-size: 12px; padding-left: 4px; padding-right: 4px" />
                     </div>
                  </div>
                  <div class="form-group row align-items-center m-2">
                     <label
                        for="or"
                        class="col-sm-4 col-form-label">
                        <strong>Override Reason</strong>
                     </label>
                     <div class="col-sm-8">
                        <textarea
                           id="or"
                           [(ngModel)]="finalComment"
                           [disabled]="readonly()"
                           ngModelOptions="{standalone: true}"
                           minlength="6"
                           #rationaleInput
                           class="form-control pricingDetailsTextarea"></textarea>
                     </div>
                  </div>
               </div>
               <div
                  class="card"
                  *ngIf="!readonly()">
                  <div class="card-body">
                     <div
                        class="grid-display mb-2 border-bottom"
                        [ngClass]="{ staleData: isStaleDate(vcProduct()?.lastScrapeDate) }">
                        <label>National Index Price</label>
                        <span>{{ vcProduct()?.nationalIndexPrice | currency }}</span>

                        <label>State Index Price</label>
                        <span>{{ vcProduct()?.stateIndexPrice | currency }}</span>

                        <label class="mainCompetitorInfo">
                           <span
                              class="staleExclamation"
                              [pTooltip]="'This data is more than 3 days old'"
                              tooltipStyleClass="pims-tooltip"
                              *ngIf="isStaleDate(vcProduct()?.lastScrapeDate)">
                              !
                           </span>
                           Competitor Price
                        </label>
                        <span class="mainCompetitorInfo">{{ vcProduct()?.competitorPrice | currency }}</span>

                        <label class="competitorInfo">Last Scrape Date</label>
                        <span class="competitorInfo">{{ vcProduct()?.lastScrapeDate | date : "M/d/yy" }}</span>

                        <label class="competitorInfo">Vetcove Online ID</label>
                        <span class="competitorInfo">
                           <a
                              *ngIf="vcProduct()?.websiteLink"
                              [href]="vcProduct()?.websiteLink"
                              target="_blank">
                              {{ vcProduct()?.websiteLink.split("item=")[1].split("&")[0] }}
                           </a>
                        </span>
                     </div>
                     @if (financialImpact()) {
                     <div
                        class="grid-display pt-2"
                        style="grid-template-columns: auto auto auto auto">
                        <label></label>
                        <label style="text-align: right">Price</label>
                        <label style="text-align: right">Rev. Impact</label>
                        <label style="text-align: right">Margin Impact</label>

                        @for (item of financialImpact(); track item.label) {
                        <label>{{ item.label }}</label>
                        <span>{{ item.value | currency }}</span>
                        <span>{{ item.revenueImpact | currency }}</span>
                        <span>{{ item.marginImpact | currency }}</span>
                        }
                     </div>

                     } @else {
                     <span class="alert alert-info">Please provide a VC product and similar product</span>
                     }
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
   <div style="display: inline-block; text-align: right; width: 35%; vertical-align: top">
      <div style="font-size: 19px; line-height: 23px">
         <strong>{{ requestData.newProductName }}</strong>
         <br />
         <span style="color: #6c6c6c; font-size: 14px; font-weight: 600">{{ practice()?.practiceName }}</span>
      </div>

      <div
         *ngIf="!readonly()"
         style="margin-top: 50px; font-weight: 600; font-size: 14px; padding-left: 30px"
         class="detailsApproveRejectButtons">
         @for (item of financialImpact(); track item.label) {
         <button
            class="v-button v-button-md v-green mt-2 text-left"
            [disabled]="!item.value || this.isSaving()"
            (click)="saveWithPrice(item.value, true)"
            style="width: 295px">
            <i class="fa fa-check"></i>
            &nbsp;&nbsp;Use {{ item.label }} Price
         </button>
         }

         <button
            *ngIf="!requestData.zohoTicketId"
            class="v-button v-button-md v-white mt-2 text-left"
            (click)="startZohoFeedback()"
            [disabled]="!finalComment()?.trim() || this.isSaving()"
            style="width: 295px">
            <i class="fa fa-user-check"></i>
            &nbsp;&nbsp;Start Zoho Feedback
         </button>
         <button
            *ngIf="requestData.zohoTicketId"
            class="v-button v-button-md v-white mt-2 text-left"
            (click)="openTicket()"
            style="width: 295px">
            <i class="fa fa-user-tag"></i>
            &nbsp;&nbsp;Open Zoho Ticket
         </button>
         <button
            class="v-button v-button-md v-white mt-2 text-left"
            (click)="saveWithPrice(this.newPrice(), undefined)"
            [disabled]="this.isSaving()"
            style="width: 295px">
            <i class="fa fa-file-download"></i>
            &nbsp;&nbsp;Save Without Feedback
         </button>
         <button
            class="v-button v-button-md v-red mt-2 text-left"
            (click)="saveWithPrice(this.newPrice(), false)"
            [disabled]="this.isSaving()"
            style="width: 295px">
            <i class="fa fa-close"></i>
            &nbsp;&nbsp;Close without providing a price
         </button>
      </div>
   </div>
</div>
<vc-price-history
   *ngIf="!!similarCode()?.pimsId && !!pricehistory()?.length"
   [title]="similarCode().productName + ' - Price Change History'"
   [priceChangeData]="pricehistory()"></vc-price-history>
